import React, { useState } from 'react';
import { PayloadFieldsForm, toPayload } from './PayloadFieldsForm';

const input = 'w-full bg-slate-900 border border-slate-600 rounded-lg px-3 py-2 text-white text-sm focus:border-emerald-500 outline-none';
const FORMS = {
  mint: { label: 'Mint check', hint: 'Issue a Treasury Check against the collateral. Leave payee blank to issue to the Treasury Reserve Wallet.', fields: [['payee_name', 'Pay to the order of (payee name, optional)'], ['to', 'Payee wallet or email (optional)'], ['amount', 'Amount (USD face)']], payload: true, optional: ['to', 'payee_name'] },
  sell: { label: 'Sell / transfer', hint: 'Deliver checks from the treasury to a buyer.', fields: [['to', 'Buyer wallet address or subscriber email'], ['amount', 'Amount (BTCK)'], ['price_usd', 'Sale price (USD)']], payload: true },
  discount: { label: 'Discount', hint: 'Deliver checks to a buyer below face value.', fields: [['to', 'Buyer wallet address or subscriber email'], ['amount', 'Amount (BTCK)'], ['discount_pct', 'Discount %']], payload: true },
  pledge: { label: 'Pledge', hint: 'Lock treasury checks as collateral for a pledgee.', fields: [['to', 'Pledgee wallet address or subscriber email'], ['amount', 'Amount (BTCK)'], ['reference', 'Pledge reference']] },
  pay: { label: 'Pay obligation', hint: 'Redeem and burn treasury checks against a paid treasury obligation.', fields: [['amount', 'Amount (BTCK)'], ['reference', 'Obligation reference']] },
};
const NUMERIC = ['amount', 'price_usd', 'discount_pct'];

export const TreasuryCheckActions = ({ onSubmit, busy }) => {
  const [kind, setKind] = useState('mint');
  const [f, setF] = useState({});
  const [p, setP] = useState({});
  const form = FORMS[kind];
  const submit = () => {
    const body = Object.fromEntries(form.fields.map(([k]) => [k, NUMERIC.includes(k) ? Number(f[k]) : (f[k] || '').trim()]));
    onSubmit(kind, form.payload ? { ...body, ...toPayload(p) } : body, () => { setF({}); setP({}); });
  };
  const ready = form.fields.every(([k]) => (form.optional || []).includes(k) || String(f[k] || '').trim());
  return (
    <div className="bg-slate-800 border border-slate-700 rounded-xl p-6" data-testid="treasury-check-actions">
      <div className="flex flex-wrap gap-2 mb-4">
        {Object.entries(FORMS).map(([k, v]) => (
          <button key={k} onClick={() => { setKind(k); setF({}); setP({}); }} data-testid={`tc-action-tab-${k}`}
            className={`px-3 py-1.5 rounded-full text-sm transition-colors ${kind === k ? 'bg-emerald-600 text-white' : 'bg-slate-700 text-slate-300 hover:bg-slate-600'}`}>{v.label}</button>
        ))}
      </div>
      <p className="text-xs text-slate-400 mb-3">{form.hint}</p>
      <div className="grid sm:grid-cols-3 gap-3">
        {form.fields.map(([k, ph]) => (
          <input key={k} value={f[k] || ''} onChange={(e) => setF({ ...f, [k]: e.target.value })} placeholder={ph} type={NUMERIC.includes(k) ? 'number' : 'text'}
            data-testid={`tc-${kind}-${k}`} className={input} />
        ))}
      </div>
      {kind === 'discount' && f.amount && f.discount_pct && <p className="text-xs text-slate-400 mt-2" data-testid="tc-discount-proceeds">Proceeds: ${(Number(f.amount) * (1 - Number(f.discount_pct) / 100)).toFixed(2)}</p>}
      {form.payload && <PayloadFieldsForm value={p} onChange={setP} prefix={`tc-${kind}`} />}
      <button onClick={submit} disabled={busy || !ready} data-testid={`tc-${kind}-submit`}
        className="mt-4 px-5 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg text-sm font-semibold disabled:opacity-40">{busy ? 'Waiting for confirmation...' : form.label}</button>
    </div>
  );
};
